import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaMarcou = (): TabelaColuna => ({
  Chave: 'marcou',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 70 }}>Marcou</div>
})
